module.exports = __webpack_public_path__ + "赵晨-3b4b4ca3.png";